import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import { useRecoilState } from 'recoil';
import Draggable from 'react-draggable';

import { roomSelector } from '../../stores/room/selectors';
import { authenticationSelector } from '../../stores/authentication/selectors';
import classnames from 'classnames';
import * as appPropTypes from '../../components/appPropTypes';
import { withRoomContext } from '../../RoomContext';
import * as requestActions from '../../redux/requestActions';
import { Appear } from '../../components/transitions';
import Me from '../Me';
import Peers from '../Peers';
import Notifications from '../Notifications';
import NetworkThrottle from '../../components/NetworkThrottle';

class Room extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            highlightState: 'NONE',
        };
    }
    render() {
        const {
            room,
            amActiveSpeaker,
            roomStore,
            recordAudio,
            roomClient,
            authenticationStore,
            type,
            isProvider,
            notCheckPermission
        } = this.props;

        console.log('notCheckPermission1',notCheckPermission);

        return (
            <Appear duration={300}>
                <div data-component="Room">
                    <Notifications />
                    {/* <If condition={recordAudio.isDebugMode}>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                            }}
                        >
                            <button
                                onClick={() => {
                                    console.log(recordAudio);
                                }}
                            >
                                Display Recored
                            </button>

                            <button
                                onClick={() => {
                                    roomClient.processUploadAudios(
                                        roomStore.roomId,
                                        authenticationStore.role
                                    );
                                }}
                            >
                                Upload File
                            </button>

                            <button
                                onClick={() => {
                                    roomClient.clearRecordAudio(
                                        roomStore.roomId,
                                        authenticationStore.role
                                    );
                                }}
                            >
                                CLear{' '}
                            </button>

                            <div>
                                <If
                                    condition={['DOCTOR', 'NURSE'].includes(
                                        authenticationStore.role
                                    )}
                                >
                                    <div
                                        style={{
                                            display: 'flex',
                                            width: '190px',
                                            justifyContent: 'space-around',
                                        }}
                                    >
                                        <div
                                            style={{
                                                padding: '0 5px',
                                                padding: '20px',
                                                borderRadius: '100%',
                                                background:
                                                    this.state.highlightState === 'RED'
                                                        ? '#FF0000'
                                                        : '',
                                            }}
                                            onClick={() => {
                                                this.setState({});
                                                roomClient.sendCommandHighlightToServer({
                                                    color: '#FF0000',
                                                    roomId: roomStore.roomId,
                                                });
                                                this.setState({ highlightState: 'RED' });
                                            }}
                                        >
                                            R
                                        </div>
                                        <div
                                            style={{
                                                padding: '0 5px',
                                                padding: '20px',
                                                borderRadius: '100%',
                                                background:
                                                    this.state.highlightState === 'YELLOW'
                                                        ? '#FFFF00'
                                                        : '',
                                            }}
                                            onClick={() => {
                                                roomClient.sendCommandHighlightToServer({
                                                    color: '#FFFF00',
                                                    roomId: roomStore.roomId,
                                                });
                                                this.setState({ highlightState: 'YELLOW' });
                                            }}
                                        >
                                            Y
                                        </div>
                                        <div
                                            style={{
                                                padding: '0 5px',
                                                background:
                                                    this.state.highlightState === 'NONE' ? '' : '',
                                                padding: '20px',
                                                borderRadius: '100%',
                                            }}
                                            onClick={() => {
                                                roomClient.sendCommandHighlightToServer({
                                                    color: 'NONE',
                                                    roomId: roomStore.roomId,
                                                });
                                                this.setState({ highlightState: 'NONE' });
                                            }}
                                        >
                                            N
                                        </div>
                                    </div>
                                </If>
                            </div>
                        </div>
                    </If> */}
                    <div className="state">
                        <div className={classnames('icon', room.state)} />
                        <p className={classnames('text', room.state)}>{room.state}</p>
                    </div>

                    <Peers notCheckPermission={notCheckPermission} type={type} isProvider={isProvider} />

                    <If condition={type === 'one' || (type === 'group' && isProvider)}>
                        <Draggable bounds="parent">
                            <div
                                className={classnames(
                                    'me-container',
                                    {
                                        'active-speaker': amActiveSpeaker,
                                    },
                                    { provider: isProvider },
                                    { patient: !isProvider }
                                )}
                            >
                                <Me isProvider={isProvider} notCheckPermission={notCheckPermission} type={type} />
                            </div>
                        </Draggable>
                    </If>

                    <If condition={window.NETWORK_THROTTLE_SECRET}>
                        <NetworkThrottle secret={window.NETWORK_THROTTLE_SECRET} />
                    </If>

                    <ReactTooltip
                        type="light"
                        effect="solid"
                        delayShow={100}
                        delayHide={100}
                        delayUpdate={50}
                    />
                </div>
            </Appear>
        );
    }

    componentDidMount() {
        const { roomClient } = this.props;
        roomClient.join();
    }
}

Room.propTypes = {
    roomClient: PropTypes.any.isRequired,
    room: appPropTypes.Room.isRequired,
    me: appPropTypes.Me.isRequired,
    amActiveSpeaker: PropTypes.bool.isRequired,
    type: PropTypes.string,
    isProvider: PropTypes.bool,
    notCheckPermission: PropTypes.any,
};

const mapStateToProps = (state) => {
    return {
        recordAudio: state.recordAudio,
        room: state.room,
        me: state.me,
        amActiveSpeaker: state.me.id === state.room.activeSpeakerId,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onRoomLinkCopy: () => {
            dispatch(
                requestActions.notify({
                    text: 'Room link copied to the clipboard',
                })
            );
        },
    };
};

const RoomContainer = withRoomContext(connect(mapStateToProps, mapDispatchToProps)(Room));

const withHook = (Component) => {
    const WrapperComponent = (props) => {
        const [authenticationStore] = useRecoilState(authenticationSelector);
        const [roomStore] = useRecoilState(roomSelector);
        return (
            <Component {...props} roomStore={roomStore} authenticationStore={authenticationStore} />
        );
    };
    return WrapperComponent;
};

export default withHook(RoomContainer);
